(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/news/assets/javascripts/views/news-list.js') >= 0) return;  svs.modules.push('/components/sport/news/assets/javascripts/views/news-list.js'); 
'use strict';

(function(Backbone, _, svs) {
  svs.sport.news.views.NewsList = Backbone.Marionette.CompositeView.extend({
    childView: svs.sport.news.views.NewsArticle,

    const: {
      NEWS_LIST: '.news-list',
      INTEGRATED: 'integrated',
      STANDARD: 'standard'
    },

    childViewContainer: '',

    collectionEvents: {
      sync: 'update'
    },

    ui: {
      newsContainer: '.news'
    },

    childViewEvents: {
      'news-article:navigate': 'navigate'
    },
    initialize: function(options) {
      this.options = _.extend({}, options);

      this.model = new svs.sport.news.models.NewsList({
        header: this.options.header,
        displayError: !this.isIntegrated()
      });
      this.collection = new svs.sport.news.collections.NewsList(
        null,
        this.options
      );

      this.collection.fetch({ silent: true });
      this.listenTo(this.collection, 'sync', this.update);
    },

    navigate: function(ev, arg) {
      this.trigger('news:navigate', arg);
    },

    isIntegrated: function() {
      return this.options.displayMode === this.const.INTEGRATED;
    },

    getTemplate: function() {
      if (this.isEmpty(this.collection) && this.isRendered) {
        return svs.sport.news.templates.news_error;
      } else if (this.options.template) {
        return this.options.template;
      }
      return svs.sport.news.templates.news_list;
    },

    update: function() {
      this.updateChildViewContainer();
      this.render();
    },

    onRender: function() {
      this.ui.newsContainer.addClass(this.options.newsClass || '');
    },

    updateChildViewContainer: function() {
      this.childViewContainer = this.isEmpty(this.collection)
        ? ''
        : this.const.NEWS_LIST;
    },

    childViewOptions: function() {
      var childOptions = { displayNavBtn: this.isIntegrated() };

      if (_.has(this.options, 'tabIndex')) {
        childOptions.tabIndex = this.options.tabIndex;
      }

      if (_.has(this.options, 'useTabletGradient')) {
        childOptions.useTabletGradient = this.options.useTabletGradient;
      }

      return childOptions;
    },

    onDestroy: function() {
      this.stopListening();

      if (this.collection) {
        this.collection.reset();
        this.collection = null;
        delete this.collection;
      }

      if (this.model) {
        this.model.destroy();
        this.model = null;
        delete this.model;
      }

      this.childViewContainer = null;
      delete this.childViewContainer;

      this.options = null;
      delete this.options;
    }
  });
})(Backbone, _, svs);

 })(window);